import { Container, Graphics } from 'pixi.js';
import type { World, EntityId } from '@/core/ECS';
import { PlayerCell, Position, Velocity, Renderable } from '@/components';
import { drawCellBody, drawCellHalo } from '@/visuals/bio';

/**
 * createCell — the player cell (eukaryote). Visual: wobbly membrane,
 * 4 orbiting mitochondria, vesicles, nucleus with nucleolus. All drawn
 * procedurally via drawCellBody; halo drawn separately so it only redraws
 * when the field radius changes.
 */
export function createCell(world: World, parent: Container, x: number, y: number): EntityId {
  const e = world.createEntity();

  const root = new Container();
  root.position.set(x, y);

  const glow = new Graphics();
  const body = new Graphics();
  root.addChild(glow, body);
  parent.addChild(root);

  drawCellHalo(glow, 90);
  drawCellBody(body, { radius: 18, fieldRadius: 90 }, 0);

  world.addComponent(e, Position, { x, y });
  world.addComponent(e, Velocity, { vx: 0, vy: 0 });
  world.addComponent(e, PlayerCell, {
    radius: 18,
    targetX: x, targetY: y,
    phase: 0,
    trail: [],
    absorptionRadius: 90,
    pulseRemaining: 0,
    haloEnabled: true,
    dashRemaining: 0,
    invulnRemaining: 0,
    dashVx: 0, dashVy: 0,
  });
  world.addComponent(e, Renderable, {
    root, body, glow, baseScale: 1, time: 0,
  });

  return e;
}
